'use client';

import { Box, Typography } from '@mui/material';

export interface HelpStepProps {
  number: number;
  text: string;
}

export function HelpStep({ number, text }: HelpStepProps) {
  return (
    <Box sx={{ display: 'flex', gap: 2, mb: 1.5, alignItems: 'flex-start' }}>
      <Box
        sx={{
          minWidth: 28,
          height: 28,
          borderRadius: '50%',
          bgcolor: 'primary.main',
          color: 'primary.contrastText',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: 14,
          fontWeight: 600,
          flexShrink: 0,
        }}
      >
        {number}
      </Box>
      <Typography variant="body2" sx={{ pt: 0.25 }}>
        {text}
      </Typography>
    </Box>
  );
}
